export const COUNTIES = [
  "Nairobi", "Mombasa", "Kisumu", "Nakuru", "Kiambu", "Machakos", "Kajiado",
  "Uasin Gishu", "Nyeri", "Meru", "Kakamega", "Kilifi", "Nyandarua", "Laikipia",
  "Trans Nzoia", "Bungoma", "Kericho", "Embu", "Kirinyaga", "Muranga", "Kisii",
  "Homa Bay", "Migori", "Garissa", "Turkana",
];

export const PROPERTY_TYPES = [
  { value: "studio", label: "Studio" },
  { value: "bedsitter", label: "Bedsitter" },
  { value: "1br", label: "1 Bedroom" },
  { value: "2br", label: "2 Bedroom" },
  { value: "3br", label: "3 Bedroom" },
  { value: "4br+", label: "4+ Bedroom" },
  { value: "single-room", label: "Single Room" },
  { value: "shared", label: "Shared (Roommates)" },
  { value: "own-compound", label: "Own Compound" },
  { value: "maisonette", label: "Maisonette" },
  { value: "bungalow", label: "Bungalow" },
  { value: "commercial", label: "Commercial / Shop" },
];

export const LISTER_TYPES = [
  { value: "landlord", label: "Landlord" },
  { value: "caretaker", label: "Caretaker" },
  { value: "host", label: "Host" },
  { value: "broker_agent", label: "Broker / Agent" },
  { value: "property_manager", label: "Property Manager" },
];

export function listerLabel(value) {
  const t = LISTER_TYPES.find((x) => x.value === value);
  return t ? t.label : "Landlord";
}

export function typeLabel(value) {
  const t = PROPERTY_TYPES.find((p) => p.value === value);
  return t ? t.label : value;
}

export function money(amount, currency) {
  const sym = currency === "USD" ? "$" : "KSh";
  return `${sym} ${Number(amount).toLocaleString()}`;
}

export const CURRENCIES = ["KSH", "USD"];

export const INSTITUTION_TYPES = [
  { value: "university", label: "University" },
  { value: "college", label: "College" },
  { value: "tvet", label: "TVET / Polytechnic" },
  { value: "other", label: "Other" },
];

export const POPULAR_INSTITUTIONS = [
  "University of Nairobi", "Kenyatta University", "JKUAT", "Strathmore University",
  "USIU-Africa", "Moi University", "Egerton University", "Technical University of Kenya",
  "Maseno University", "KCA University", "Mount Kenya University", "Daystar University",
  "Dedan Kimathi University", "Multimedia University", "Zetech University",
];

export const AMENITIES = [
  "Bed", "Study desk", "Wardrobe", "Common kitchen", "Private kitchen", "WiFi",
  "Water 24/7", "Electricity token", "Furnished", "Hot shower", "Laundry",
  "Parking", "Security / CCTV", "Backup power", "Gym", "Cafeteria",
];

export const SHORT_TERM_ADDONS = [
  "WiFi", "Air conditioning", "Heating", "Fully equipped kitchen", "Microwave",
  "Refrigerator", "Coffee maker", "Washer", "Dryer", "Iron", "Hair dryer",
  "Essentials (towels & soap)", "Bed linens", "Free parking", "Paid parking",
  "Swimming pool", "Hot tub", "Gym", "Elevator / Lift", "Smart TV / Netflix",
  "Dedicated workspace", "Self check-in", "Lockbox", "Backup power / Generator",
  "Hot water", "Balcony", "Garden / Backyard", "BBQ grill", "Breakfast included",
  "Daily cleaning", "Airport pickup", "Smoke alarm", "Fire extinguisher",
  "First aid kit", "Security / CCTV", "Gated community", "Pets allowed",
  "Smoking allowed", "Wheelchair accessible", "Crib / Baby cot", "High chair",
  "Beachfront", "Lake access", "Mountain view", "City view", "Private entrance",
];

export const LISTING_TYPES = [
  { value: "rent", label: "For Rent" },
  { value: "sale", label: "For Sale" },
  { value: "short_term", label: "Short-term Stay" },
];

export function priceSuffix(listingType) {
  if (listingType === "short_term") return "/night";
  if (listingType === "rent") return "/month";
  return "";
}

export function listingTypeLabel(value) {
  const t = LISTING_TYPES.find((x) => x.value === value);
  return t ? t.label : value;
}

export const GENDER_PREF = [
  { value: "any", label: "Any" },
  { value: "male", label: "Male only" },
  { value: "female", label: "Female only" },
];

export const SHARED_PROPERTY_TYPES = ["shared", "single-room"];

export function isSharedType(value) {
  return SHARED_PROPERTY_TYPES.includes(value);
}

export function genderPrefLabel(value) {
  const g = GENDER_PREF.find((x) => x.value === value);
  return g ? g.label : "Any";
}

export const STATUS_META = {
  active: { label: "Available", color: "#2C3830", bg: "#E7EFE9" },
  rented: { label: "Rented", color: "#B45309", bg: "#FEF3C7" },
  sold: { label: "Sold", color: "#B91C1C", bg: "#FEE2E2" },
};

// Approximate coordinates (main town) per county for the area map locator
export const COUNTY_COORDS = {
  Nairobi: [-1.286, 36.817], Mombasa: [-4.043, 39.668], Kisumu: [-0.0917, 34.768],
  Nakuru: [-0.303, 36.08], Kiambu: [-1.171, 36.836], Machakos: [-1.516, 37.263],
  Kajiado: [-1.852, 36.776], "Uasin Gishu": [0.514, 35.269], Nyeri: [-0.417, 36.951],
  Meru: [0.047, 37.649], Kakamega: [0.282, 34.752], Kilifi: [-3.51, 39.909],
  Nyandarua: [-0.18, 36.523], Laikipia: [0.007, 37.073], "Trans Nzoia": [1.019, 35.002],
  Bungoma: [0.563, 34.56], Kericho: [-0.367, 35.283], Embu: [-0.538, 37.457],
  Kirinyaga: [-0.499, 37.28], Muranga: [-0.721, 37.15], Kisii: [-0.681, 34.767],
  "Homa Bay": [-0.527, 34.457], Migori: [-1.063, 34.473], Garissa: [-0.453, 39.646],
  Turkana: [3.119, 35.597],
};

export const KENYA_CENTER = [-0.5, 37.5];
